import { render, staticRenderFns } from "./campaign-expand-column.vue?vue&type=template&id=10e2e784"
import script from "./campaign-expand-column.vue?vue&type=script&lang=js"
export * from "./campaign-expand-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e2e784')) {
      api.createRecord('10e2e784', component.options)
    } else {
      api.reload('10e2e784', component.options)
    }
    module.hot.accept("./campaign-expand-column.vue?vue&type=template&id=10e2e784", function () {
      api.rerender('10e2e784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/campaign/campaign-expand-column.vue"
export default component.exports